export default {
  from: 'מתאריך',
  till: 'עד תאריך',
  number: 'מספר הסכם',
  agent: 'מספר סוכן',
  company: 'חברה מנהלת',
  branch: 'מוצר',
  branches: 'מוצרים',
  addAgreement: 'הוספת הסכם',
  accordType: 'סוג הסכם',
  accordName: 'שם הסכם',
  success: 'ההסכם נוסף בהצלחה',
  failture: 'התרחשה שגיאה בהוספת ההסכם',
  commision: {
    agentFeeMonthlyDeposit: 'עמלת סוכן נפרעים מהפקדה %',
    agentFeeMonthlyAccumulation: 'עמלת סוכן נפרעים מצבירה %',
    agentFeeAnnualAccumulation: 'עמלת סוכן היקף מצבירה %',
    agentFeeAnnualDeposit: 'עמלת סוכן היקף מהפקדה %',
    employeeAgentCommission: 'עמלת סוכן שכיר %',
  },
};
